<template>
  <div class="empty-container">
    <img src="@/assets/empty/none.png" alt="" />
    <div class="content med_font_20">{{ content }}</div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      typeof: String,
      default: '内容空空如也'
    }
  }
}
</script>

<style lang="less" scoped>
.empty-container {
  .content {
    margin-top: 60px;
    color: #636975;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/empty/index.vue